var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconZoom = function SvgIconZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon_zoom_svg__a",
    width: 96,
    height: 96,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5047ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_zoom_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#5047ff",
    "data-name": "Ellipse 15",
    transform: "translate(24 23)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m53.106 50.054 6.843 6.846-2.05 2.05-6.843-6.843v-1.081l-.37-.383a8.909 8.909 0 1 1 .958-.958l.383.37h1.081m-8.211 0a6.159 6.159 0 1 0-6.161-6.155 6.133 6.133 0 0 0 6.163 6.154m3.421-5.474h-2.741v2.737H44.21V44.58h-2.737v-1.369h2.737v-2.737h1.369v2.737h2.737Z",
    "data-name": "Path / magnify-plus-outline"
  })));
};
export default SvgIconZoom;